module.exports = __webpack_public_path__ + "a9f5b8cb2ab1f50523bd908e23d824b5.jpg";